import AsyncStorage from "@react-native-async-storage/async-storage";
import http from "./";

export const registerUser1 = async (user) => {
    try {
        const { status } = await http.post(
            `${http.url2}/users/registerSMS`,
            JSON.stringify(user)
        );
        return status;
    } catch (err) {
        console.log(err);
    }
};

export const registerUser2 = async (user) => {
    try {
        const { status } = await http.post(
            `${http.url2}/users`,
            JSON.stringify(user)
        );
        return status;
    } catch (err) {
        console.log(err);
    }
};

export const loginUser = async (user) => {
    try {
        const { data, status } = await http.post(
            `${http.url2}/login`,
            JSON.stringify(user)
        );

        await AsyncStorage.setItem("token", JSON.stringify(data.token));
        await AsyncStorage.setItem("userId", JSON.stringify(data.userId));
        return status;
    } catch (err) {
        console.log(err);
    }
};
